(function () {
  const cfg = readConfig();
  if (!cfg || !cfg.enabled) return;

  const params = new URLSearchParams(window.location.search);
  const firstParam = params.get(cfg.param);
  if (!firstParam) return;

  const parsed = parseFirstParam(firstParam, params.get('variant'));
  if (!parsed.handle) return;

  const state = {
    cachedCardHtml: null,
    pinning: false,
    failed: false,
    inflight: false,
    variantImageSrc: null,
    variantImageInflight: false,
  };
  pin(parsed, state);
  observeGridChanges(parsed, state);

  function readConfig() {
    const el = document.querySelector('script[data-curated-first]');
    if (!el) return null;
    return { enabled: true, param: el.dataset.param || 'first' };
  }

  function parseFirstParam(firstParam, fallbackVariant) {
    let candidate = firstParam;
    let variant = fallbackVariant || null;

    if (!/^https?:\/\//.test(candidate)) {
      try {
        const maybeDecoded = decodeURIComponent(candidate);
        if (/^https?:\/\//.test(maybeDecoded)) candidate = maybeDecoded;
      } catch (e) {}
    }

    let handle = candidate;
    if (/^https?:\/\//.test(candidate)) {
      try {
        const url = new URL(candidate);
        const parts = url.pathname.split('/');
        const idx = parts.indexOf('products');
        handle = idx !== -1 && parts[idx + 1] ? parts[idx + 1] : '';
        if (!variant) variant = new URLSearchParams(url.search).get('variant');
      } catch (e) {
        handle = '';
      }
    }

    handle = (handle || '').split('?')[0].split('#')[0].split('/').pop() || '';
    variant = (variant || '').replace(/[^0-9]/g, '') || null;
    return { handle: handle, variant: variant };
  }

  function getGrid() {
    return document.querySelector('#product-grid');
  }

  function getCards(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll(':scope > li'));
  }

  function linkMatchesHandle(href, handle) {
    if (!href) return false;
    const marker = '/products/' + handle;
    const at = href.indexOf(marker);
    if (at === -1) return false;
    const next = href.charAt(at + marker.length);
    return next === '' || next === '?' || next === '#' || next === '/';
  }

  function cardMatchesHandle(card, handle) {
    const links = card.querySelectorAll('a[href*="/products/"]');
    for (let i = 0; i < links.length; i++) {
      if (linkMatchesHandle(links[i].getAttribute('href'), handle)) return true;
    }
    return false;
  }

  function findCardByHandle(grid, handle) {
    const cards = getCards(grid);
    for (let i = 0; i < cards.length; i++) {
      if (cardMatchesHandle(cards[i], handle)) return cards[i];
    }
    return null;
  }

  function findOtherCardWithHandle(grid, exclude, handle) {
    const cards = getCards(grid);
    for (let i = 0; i < cards.length; i++) {
      if (cards[i] !== exclude && cardMatchesHandle(cards[i], handle)) return cards[i];
    }
    return null;
  }

  function pin(parsed, state) {
    const cfg = readConfig();
    if (!cfg) return;
    if (!new URLSearchParams(window.location.search).get(cfg.param)) return;

    const grid = getGrid();
    if (!grid || state.pinning) return;

    const firstCard = grid.querySelector(':scope > li');
    if (firstCard && cardMatchesHandle(firstCard, parsed.handle)) {
      const duplicate = findOtherCardWithHandle(grid, firstCard, parsed.handle);
      if (duplicate) duplicate.remove();
      if (parsed.variant) applyVariant(firstCard, parsed.handle, parsed.variant, state);
      return;
    }

    state.pinning = true;
    try {
      const existing = findCardByHandle(grid, parsed.handle);
      if (existing) {
        moveToFront(grid, existing);
        if (parsed.variant) applyVariant(existing, parsed.handle, parsed.variant, state);
      } else if (state.cachedCardHtml) {
        insertFetchedCard(grid, state.cachedCardHtml, parsed, state);
      } else if (!state.failed && !state.inflight) {
        fetchAndPin(grid, parsed, state);
      }
    } finally {
      state.pinning = false;
    }
  }

  function moveToFront(grid, card) {
    const first = grid.querySelector(':scope > li');
    if (first === card) return;
    grid.insertBefore(card, first || grid.firstElementChild);
  }

  function insertFetchedCard(grid, html, parsed, state) {
    if (findCardByHandle(grid, parsed.handle)) return;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const card = wrapper.querySelector('li');
    if (!card) return;

    const first = grid.querySelector(':scope > li');
    grid.insertBefore(card, first || grid.firstElementChild);
    if (parsed.variant) applyVariant(card, parsed.handle, parsed.variant, state);
  }

  function fetchAndPin(grid, parsed, state) {
    state.inflight = true;
    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const rootPrefixed = rootUrl.charAt(rootUrl.length - 1) === '/' ? rootUrl : rootUrl + '/';
    const fetchUrl = rootPrefixed + 'products/' + parsed.handle + '?section_id=curated-product-card';

    fetch(fetchUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Section returned ' + res.status);
        return res.text();
      })
      .then(function (html) {
        state.inflight = false;
        if (!html || html.indexOf('/products/' + parsed.handle) === -1) {
          throw new Error('Rendered card does not match handle ' + parsed.handle);
        }
        state.cachedCardHtml = html;
        const liveGrid = getGrid();
        if (!liveGrid) return;
        insertFetchedCard(liveGrid, html, parsed, state);
      })
      .catch(function (err) {
        state.failed = true;
        state.inflight = false;
        if (window.console) console.warn('[curated-first] could not pin product:', err.message);
      });
  }

  function applyVariant(card, handle, variantId, state) {
    if (!variantId) return;
    setVariantOnLinks(card, handle, variantId);
    if (state.variantImageSrc) {
      swapImage(card, state.variantImageSrc);
    } else if (!state.variantImageInflight) {
      swapVariantImage(card, handle, variantId, state);
    }
  }

  function setVariantOnLinks(card, handle, variantId) {
    const links = card.querySelectorAll('a[href*="/products/"]');
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      const href = link.getAttribute('href');
      if (!href || !linkMatchesHandle(href, handle)) continue;
      link.setAttribute('href', withVariantParam(href, variantId));
    }
  }

  function withVariantParam(href, variantId) {
    try {
      const url = new URL(href, window.location.origin);
      url.searchParams.set('variant', variantId);
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  function swapVariantImage(card, handle, variantId, state) {
    state.variantImageInflight = true;
    const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const rootPrefixed = rootUrl.charAt(rootUrl.length - 1) === '/' ? rootUrl : rootUrl + '/';

    fetch(rootPrefixed + 'products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('product.js ' + res.status);
        return res.json();
      })
      .then(function (product) {
        state.variantImageInflight = false;
        const idNum = parseInt(variantId, 10);
        let variant = null;
        for (let i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === idNum) {
            variant = product.variants[i];
            break;
          }
        }
        if (!variant || !variant.featured_image || !variant.featured_image.src) return;
        state.variantImageSrc = variant.featured_image.src;

        const liveGrid = getGrid();
        const liveCard = liveGrid ? findCardByHandle(liveGrid, handle) : null;
        swapImage(liveCard || card, state.variantImageSrc);
      })
      .catch(function () {
        state.variantImageInflight = false;
      });
  }

  function swapImage(card, imageSrc) {
    if (!card || card.dataset.curatedVariantSwapped === imageSrc) return;
    const img = card.querySelector('.card__media img');
    if (!img) return;

    let base;
    try {
      base = new URL(imageSrc, window.location.href);
    } catch (e) {
      return;
    }

    const widths = [165, 360, 533, 720, 940, 1066];
    img.setAttribute('src', resizeSrc(base, 533));
    img.setAttribute(
      'srcset',
      widths.map(function (w) { return resizeSrc(base, w) + ' ' + w + 'w'; }).join(', ')
    );
    card.dataset.curatedVariantSwapped = imageSrc;
  }

  function resizeSrc(base, width) {
    const url = new URL(base.href);
    url.searchParams.set('width', String(width));
    return url.toString();
  }

  function observeGridChanges(parsed, state) {
    const container = document.getElementById('ProductGridContainer');
    if (!container || typeof MutationObserver === 'undefined') return;
    let rafId = 0;
    const observer = new MutationObserver(function () {
      if (state.pinning || rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = 0;
        pin(parsed, state);
      });
    });
    observer.observe(container, { childList: true, subtree: true });
  }
})();
